// ACTIONS
export const FETCH = 'offerzen/profileCompletion/FETCH'
export const FETCH_SUCCESS = 'offerzen/profileCompletion/FETCH_SUCCESS'

// ACTION CREATORS
export const fetchCompletion = id => ({
  type: FETCH,
  payload: { id },
})

export const fetchCompletionSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: { data },
})

// REDUCERS
const initialState = {
  completion_percentage: 0,
  incomplete_sections: [],
}

const profileCompletionReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUCCESS:
      return {
        ...state,
        ...action.payload.data,
      }

    default:
      return state
  }
}

export default profileCompletionReducer

export const getProfileCompletionView = state => state.views.profile.profileCompletion || initialState
